var parent = require('../../es/instance/map');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/stable/instance/map.js
// module id = 365
// module chunks = 0 1